import React, { useEffect, useState } from 'react'
import Button from '../../../../atoms/Button/Button'
import UploadLoghi from '../../../../organisms/UploadLoghi/UploadLoghi'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'
import { trackingGAEventProdotto } from '../../../../../utils/gtm'
import useTrans from '../../../../../hooks/useTrans'

const CaricamentoLoghi = ({ setStep, step, props }) => {
  const t = useTrans()
  const [files, setFiles] = useState(null)
  const [Conferma, setConferma] = useState(false)
  const [caricaInSeguito, setCaricaInSeguito] = useState(false)

  useEffect(() => {
    //files && Object.values(files).length > 0 ? setConferma(true) : setConferma(false)
    if (files) {
      if (props.values?.stesso_logo) {
        if (Object.values(files).length > 0) {
          setConferma(true)
        } else {
          setConferma(false)
        }
      } else {
        if (Object.values(files).length > 1) {
          setConferma(true)
        } else {
          setConferma(false)
        }
      }
    } else {
      setConferma(false)
    }
    props.setFieldValue('files', files)
  }, [files])

  const isDisabled = () => {
    if (Conferma && !caricaInSeguito) {
      return false
    }
    if (!Conferma && caricaInSeguito) {
      return false
    }
    return true
  }

  return (
    <div className="caricamento-loghi">
      {!caricaInSeguito && (
        <div className="caricamento-loghi__positions">
          <UploadLoghi
            posizioni={props.values?.stesso_logo ? [0] : [0, 1]}
            setFromProps={setFiles}
          />
        </div>
      )}

      {!Conferma && (
        <div className="caricamento-loghi__postpone">
          <FormCheckbox
            label={t('Carica i loghi in seguito')}
            checked={caricaInSeguito}
            onChange={() => {
              setCaricaInSeguito(!caricaInSeguito)
              setFiles(null)
            }}
          />
        </div>
      )}

      <div className="caricamento-loghi__confirm">
        <Button
          onClick={() => {
            setStep(step + 1)
            const first_articolo =
              props?.values?.prodotto?.articoli.length > 0
                ? props?.values?.prodotto?.articoli[0]
                : null
            trackingGAEventProdotto(
              'customization_funnel',
              'c_step4_caricamento_loghi',
              undefined,
              first_articolo?.titolo || '',
              props?.values?.prodotto?.codice || ''
            )
          }}
          label={t('Conferma selezione')}
          variant="primary"
          size="large"
          disabled={isDisabled()}
        />
      </div>
    </div>
  )
}

export default CaricamentoLoghi
